import { useQuery } from '@tanstack/react-query'

import { useSettings } from '@loadsmart/react-frontend-settings'

import { useSession } from 'auth/ui/hooks/useSession'
import { isForbiddenError } from 'core/infra/http/errors'
import { useSettingsSettled } from 'core/ui/hooks/useSettingsSettled'
import { getOpenDockReports } from 'managed-analytics/use-cases/getOpenDockReports'

import { resolveOpenDockPdfReportsAccess } from './resolveOpenDockPdfReportsAccess'

export const OPENDOCK_PDF_REPORTS_FLAG = 'flags.ENABLE_OPENDOCK_PDF_REPORTS'

export function useOpenDockPdfReportsAccess() {
  const session = useSession()
  const settingsSettled = useSettingsSettled()
  const { isLoading: isSettingsLoading, values } = useSettings([OPENDOCK_PDF_REPORTS_FLAG])
  const isFlagLoading = !settingsSettled || isSettingsLoading
  const isFlagEnabled = values?.[0] === null || values?.[0] === undefined ? null : Boolean(values[0])
  const isOpenDock = session?.user.issuer === 'opendock'
  const orgId = session?.user.org_id ?? session?.user.client ?? null

  const { shouldFetch } = resolveOpenDockPdfReportsAccess({
    hasSession: Boolean(session),
    isOpenDock,
    isFlagLoading,
    isFlagEnabled,
    isFetched: false,
  })

  const query = useQuery({
    queryKey: ['opendockReports', orgId],
    queryFn: ({ signal }) => getOpenDockReports({ signal }),
    enabled: shouldFetch,
    retry: false,
  })

  const isForbidden = isForbiddenError(query.error)
  const { isLoading, isNavVisible } = resolveOpenDockPdfReportsAccess({
    hasSession: Boolean(session),
    isOpenDock,
    isFlagLoading,
    isFlagEnabled,
    isFetched: query.isFetched,
    isForbidden,
  })

  return {
    isLoading,
    isNavVisible,
    reports: query.data ?? [],
    isError: query.isError && !isForbidden,
    isForbidden,
  }
}
